module.exports = __webpack_public_path__ + "img/Usable.633cf35b.svg";